import React, { useState } from "react";
import "./subscription.scss";
import Subscription from "../Subscription";
import platzi from "../../assets/images/platzi-logo.png";
import udemy from "../../assets/images/udemy-logo.png";
import doodlewarriorsacademy from "../../assets/images/doodlewarriorsacademy-logo.png";
import domestika from "../../assets/images/domestika-logo.png";
import skillshare from "../../assets/images/skillshare-logo.png";
import codely from "../../assets/images/codely-logo.png";
import emprendeaprendiendo from "../../assets/images/emprendeaprendiendo-logo.png";
import artschool from "../../assets/images/artschool-logo.jpg";

const Subscriptions = () => {
  const [showStatus, setShowStatus] = useState(false);

  const checkStatus = () => {
    setShowStatus(!showStatus);
  };

  return (
    <div className="subscription">
      <div>
        <button className="subscription__button" onClick={checkStatus}>
          <p className="subscription__message">Check status</p>
        </button>
      </div>
      <div className="subscription__subtitle">
        <h3>Study & Learn </h3>
        <h4>(7 subscriptions)</h4>
      </div>
      <div className="subscription__subtitle">
        <h4>All</h4>
      </div>
      <div className="subscription__items-container">
        <Subscription
          href="https://platzi.com/home"
          src={platzi}
          alt="Platzi"
          hrefPayment="https://platzi.com/mi-suscripcion/"
          paymentMessage="Tu próximo pago será de $ 113.290 CLP el 22/12/2023"
          variant="next-year"
          showStatus={showStatus}
        ></Subscription>

        <Subscription
          href="https://www.skillshare.com/home"
          src={skillshare}
          alt="Skillshare"
          hrefPayment="https://www.skillshare.com/en/settings/payments"
          paymentMessage="Your next yearly charge of US$99.00 will be applied to your
          primary payment method on September 3, 2023."
          assignedColor="orange"
          variant="next-year"
          showStatus={showStatus}
        ></Subscription>
      </div>
      <div className="subscription__subtitle">
        <h4>Code</h4>
      </div>
      <div className="subscription__items-container">
        <Subscription
          href="https://pro.codely.tv/home/"
          src={codely}
          alt="Codely"
          hrefPayment="https://pro.codely.com/manage/profile/billing/"
          paymentMessage="You have free access until November 18th 2023, after which your
          card will be charged 29,00 €/monthly."
          variant="next-year"
          assignedColor="blue"
          showStatus={showStatus}
        ></Subscription>
        <Subscription
          href="https://www.udemy.com/home/my-courses/learning/"
          src={udemy}
          alt="Udemy"
          assignedColor="rose"
          paymentMessage="Completed"
          showStatus={showStatus}
        ></Subscription>
      </div>
      <div className="subscription__subtitle">
        <h4>Art</h4>
      </div>
      <div className="subscription__items-container">
        <Subscription
          href="https://www.domestika.org/es/my_courses"
          src={domestika}
          alt="Domestika"
          assignedColor="blue"
          paymentMessage="Completed"
          showStatus={showStatus}
        ></Subscription>
        <Subscription
          href="https://academy.doodlewarriors.com/"
          src={doodlewarriorsacademy}
          alt="doodlewarriors - academy"
          assignedColor="orange"
          paymentMessage="Completed"
          showStatus={showStatus}
        ></Subscription>
        <Subscription
          href="https://cubebrush.co/mb/products/0dpzeg"
          src={artschool}
          alt="ARTSchool for digital artists"
          assignedColor="green"
          paymentMessage="Completed"
          showStatus={showStatus}
        ></Subscription>
      </div>
      <div className="subscription__subtitle">
        <h3>Audiobook</h3>
        <h4>(1 subscriptions)</h4>
      </div>
      <div className="subscription__subtitle">
        <h4>Entrepreneurship</h4>
      </div>
      <div className="subscription__items-container">
        <Subscription
          href="https://academia.emprendeaprendiendo.com/enrollments"
          src={emprendeaprendiendo}
          alt="emprendeaprendiendo"
          assignedColor="purple"
          paymentMessage="Completed"
          showStatus={showStatus}
        ></Subscription>
      </div>
    </div>
  );
};
export default Subscriptions;
